import React, { useEffect, useState } from "react";
import { useDoubleTap } from "use-double-tap";
import SelectIcon from "../../../assets/Modals/SelectIcon";
import SelectedIcon from "../../../assets/Modals/SelectedIcon";
import { ChatMessageType } from "../../../services/apiTypes";
import UserIcon from "../../UserIcon";
import MessageModal from "../Modals/MessageModal";
import MessageOptions from "./Options";
import { LikedIconWrapper, MessageComponentsWrapper, MessageWrapper, SelectIconWrapper, Text, TextWrapper } from "./styles";

type MessageProps = {
  message: ChatMessageType;
  sent: boolean,
  handleMessageSelection: (messageId: ChatMessageType) => void;
  selectingMessages: boolean;
  scrollPosition: number;
  scrollHeight: number;
  setAnsweringMessage: (message: ChatMessageType | undefined) => void;
  isUserLastMessage: boolean;
  oneModalIsOpen: string;
  setOneModalIsOpen: (state: string) => void;
}

export default function Message({
  message,
  sent,
  handleMessageSelection,
  selectingMessages,
  scrollPosition,
  scrollHeight,
  setAnsweringMessage,
  isUserLastMessage,
  oneModalIsOpen,
  setOneModalIsOpen,
}: MessageProps) {
  const [selected, setSelected] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [hovering, setHovering] = useState(false);
  const [messageModal, setMessageModal] = useState(false);

  const bindDoubleTap = useDoubleTap(() => {
    setIsLiked(!isLiked);
  });

  useEffect(() => {
    if (!selectingMessages) {
      setSelected(false);
    }
  }, [selectingMessages]);

  const handleModal = () => {
    if (oneModalIsOpen !== message.id) {
      setOneModalIsOpen(message.id);
      setMessageModal(!messageModal);
    } else {
      setMessageModal(false);
      setOneModalIsOpen('');
    }
  }

  const optionsButtonRef = React.useRef<any>(null);
  const [positionRect, setPositionRect] = useState<any>(null);

  useEffect(() => {
    if (optionsButtonRef.current) {
      const rect = optionsButtonRef.current.getBoundingClientRect();
      setPositionRect(rect);
    }
  }, []);

  const handleMessageModalActions = (action: string) => {
    switch (action) {
      case 'delete':
        console.log('delete');
        break;
      case 'copy':
        console.log('copy');
        break;
      case 'share':
        console.log('share');
        break;
      case 'select':
        console.log('select');
        setSelected(!selected);
        setMessageModal(false);
        handleMessageSelection(message)
        break;
      default:
        break;
    }
  }

  const handleAnswer = () => {
    setAnsweringMessage(message);
  }

  useEffect(() => {
    if (oneModalIsOpen !== message.id) {
      setMessageModal(false);
    }
  }, [oneModalIsOpen]);

  return (
    <MessageWrapper
      sent={sent ? true : false}
      selected={selected}
      selectingMessages={selectingMessages}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      {(selectingMessages) ? (
        selected ?
          <SelectIconWrapper onClick={() => setSelected(!selected)}>
            <SelectedIcon />
          </SelectIconWrapper>
          :
          <SelectIconWrapper onClick={() => setSelected(!selected)}>
            <SelectIcon />
          </SelectIconWrapper>
      ) : null}
      <MessageComponentsWrapper style={{ marginLeft: (!sent && !isUserLastMessage) ? 40 : 0 }}>
        {(hovering && !selectingMessages && sent) ? (
          <MessageOptions
            isLiked={isLiked}
            setIsLiked={setIsLiked}
            handleAnswer={handleAnswer}
            handleModal={handleModal}
          />
        ) : null}
        {(isUserLastMessage && !sent && !selectingMessages) ? (
          <div style={{ alignSelf: 'flex-end' }}>
            <UserIcon icon={'https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png'} size='m' />
          </div>
        ) : null}
        <TextWrapper
          {...bindDoubleTap}
          sent={sent}
          ref={optionsButtonRef}
        >
          <Text>
            {message.content}
          </Text>
          {isLiked ?
            <LikedIconWrapper sent={sent}>
              <HeartIcon />
            </LikedIconWrapper>
            :
            null}
        </TextWrapper>
        {(hovering && !selectingMessages && !sent) ? (
          <MessageOptions
            isLiked={isLiked}
            setIsLiked={setIsLiked}
            handleAnswer={handleAnswer}
            handleModal={handleModal}
          />
        ) : null}
      </MessageComponentsWrapper>
      {messageModal ?
        <MessageModal
          positionRect={positionRect}
          scrollPosition={scrollPosition}
          scrollHeight={scrollHeight}
          open={messageModal}
          authorUsername={message.parentId}
          onAction={handleMessageModalActions}
          sent={sent}
          setModal={setMessageModal}
        />
        : null}
    </MessageWrapper>
  );
}

function HeartIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="19"
      fill="none"
      viewBox="0 0 28 19"
    >
      <rect
        width="28"
        height="18.466"
        y="0.467"
        fill="#F5F5F5"
        rx="9.233"
      ></rect>
      <path
        fill="#F33333"
        d="M19.075 5.392a3.158 3.158 0 00-4.467 0L14 6.001l-.609-.609a3.158 3.158 0 10-4.466 4.466l.609.609L14 14.933l4.466-4.466.609-.609a3.159 3.159 0 000-4.466z"
      ></path>
    </svg>
  );
}